module.exports = __webpack_public_path__ + "img/panic_ios_802.png";